export const Contact = {
  tel: "+216 36 38 68 25",
  email: "contact@bet216.tn",
  fax: "+216 36 38 68 25",
  addresse:
    "Immeuble le 45,Bloc A 3eme Etage Bureau A 3.3 , Rue du Japon , Montplaisir 1073- Tunis-Tunisie",
};

export const EndPoints = {
  resendActivation: "user/resendActivation",
  slides: "system/sliders",
  userManager: "UserManager",
  register: "customer-service/new",
  quickSignup: "customer-service/register",
  resendMail: "user/resendActivation",
  userLoginSession: "user/login/",
  login: "user/login-api",
  login_with_phonenumber: "user/phonenumber-login-api",
  partners: "partners/active",
  promotions: 'site_info/all',
  logout: "user/logout",
  logoutCustomer: "user/close-session",
  transactions: "transac-service/bets",
  transactionsHistory: "transaction/history",
  pmu_transactions: "ser_customer_transaction",
  armel_transactions: "ser_customer_transaction",
  sportcash_transactions: "v1/transaction/verify-ticket/",
  transactionDetails: "ser_customer_transaction",
  payment_transactions: "getTransactions",
  updateProfile: "user/updateProfile",
  changePassword: "user/updatePassword",
  customerTransactions: "transac-service/customer-transaction",
  verifyPhone: "user/validate-phn",
  confirmCodeURL: "user/verifyAccountBySms",
  allPartners: "partners/all",
  allProducts: "products/all",
  resendVerificationCodeBySMS: "user/resendSMSActivationCode",
  changePin: "user/updatePin",
  providers: "provider-service/",
  DIZAPAY_WITHDRAWAL_CONFIRMATION: "ser_web_retrait_momo_box",
  DIZAPAY_DEPOSIT_CONFIRMATION: "ser_validate_visa_transaction",
  DIZAPAY_WITHDRAWAL: "ser_web_retrait_momo_box",
  DIZAPAY_DEPOSIT: "ser_web_recharge_momo_box",
  LONACI_DEPOSIT: "ser_refill_local_coupon",
  saveCoupon: "coupon/save",
  loadCoupon: "coupon/",
  recover1: "user/recoverAccount",
  verifyEmail: "user/validate-email",
  verifyUserName: "user/validate-user",
  securityQuestions: "user/getQuestions",
  recover2: "user/recoverAccount/changePassword",
  systemConfigs: "system/configs",
  SOBFLOUSVOUCHER: "ser_refill_local_coupon",
  SOBFLOUS: "ser_sobflous_recharge",
  SOBFLOUSVOUCHER_DEPOSIT: "ser_refill_local_coupon",
  ALLIANCETECH_DEPOSIT: "ser_refill_local_coupon",
  SOBFLOUS_DEPOSIT: "ser_sobflous_recharge",
  SOBFLOUS_WITHDRAWAL: "ser_sobflous_retrait",
  BET216: "ser_refill_local_coupon",
  BET221_DEPOSIT: "ser_refill_local_coupon",
  SPORTCASH_DEPOSIT: "ser_refill_local_coupon",
  SPORTCASHCOUPON_DEPOSIT: "ser_refill_local_coupon",

  VIAMOBILE: "ser_refill_local_coupon",
  BANKTRANSFER: "ser_bank_transfer",

  LATETS_WINNERS: "agent-servicev2/winners/5",
  REQUEST_OTP: "user/otp/generate",
  savePaymentAccnt: "provider-service/sendConfirmCode",
  confirmOtpPayment: "provider-service/confirmAccount",
  sessionverification: "/API/customer/session/validate",
  registerAnonym: "customer-service/register_ussd",
  placeBetMiss: "web/miss",
  calendar: "calendar",
  saveBet: "ser_hippique_bet",
  getBonusDetails: 'customer_bonus_details',
  getBonusTransDetails: 'transactions/',
  getBonusUsageDetails: 'bonus-production/bonus-usage/admin/en',
  bonus_transactions: 'bonus/customer/',
  user_balance: "",
  transactionSummary: "/transaction-summary",

  // comment for v1

  LIVE_DATA: "sport/event/liveEvents",
  all_sports: "sport/list",
  LATEST_RESULTS: "sport/results/period/",
  SPORTCASHWITHDRAWAL_WITHDRAWAL: "ser_generate_withdrawal_code",
  BET216WITHDRAWAL: "ser_generate_withdrawal_code",
  BET221WITHDRAWAL: "ser_generate_withdrawal_code",
  BET221WITHDRAWAL_WITHDRAWAL: "ser_generate_withdrawal_code",
  SPORTCASH_WITHDRAWAL: "ser_generate_withdrawal_code",
  SPORTCASHCOUPON_WITHDRAWAL: "ser_generate_withdrawal_code",
  sports: "sport/",
  events: "sport/event",
  cashout: "cashout/offer",
  completeCashout: "cashout",
  PAYTUS_GATEWAY_DEPOSIT: "ser_web_recharge",
  PAYTUS_GATEWAY_WITHDRAWAL: "ser_web_retrait",
  refreshToken: "api/v1/authorize/refreshToken",
  partnerBonuses: "bonus-consumer-controler/bonus/active/",
  confirm_account: 'user/verifyAccount',
  verify_user: 'user/kyc-init',
  user_verification_status: 'kyc-check-status/',

  /**
   * LIMITS ENDPOINTS
   */
  setLimits: "user/add-limits",
  getLimits: "user/customer-limits/",
  confirmSelfExclusion: "user/self-exclude",
  selfExcludeUnsuspendOTP: "user/self-unsuspend-otp",
  selfRecoverAccount: "user/self-unsuspend"
};

export const PaymentEndpoints = {
  DIZAPAY_WITHDRAWAL_CONFIRMATION: "ser_web_retrait_momo_box",
  DIZAPAY_DEPOSIT_CONFIRMATION: "ser_validate_visa_transaction",
  DIZAPAY_WITHDRAWAL: "ser_web_retrait_momo_box",
  DIZAPAY_DEPOSIT: "ser_web_recharge_momo_box",
  LONACI_DEPOSIT: "ser_refill_local_coupon",
  LONACICOUPON_DEPOSIT: "ser_refill_local_coupon",

  SOBFLOUSVOUCHER: "ser_refill_local_coupon",
  SOBFLOUS: "ser_sobflous_recharge",
  SOBFLOUSVOUCHER_DEPOSIT: "ser_refill_local_coupon",
  ALLIANCETECH_DEPOSIT: "ser_refill_local_coupon",
  SOBFLOUS_DEPOSIT: "ser_sobflous_recharge",
  SOBFLOUS_WITHDRAWAL: "ser_sobflous_retrait",
  BET216: "ser_refill_local_coupon",
  BET221_DEPOSIT: "ser_refill_local_coupon",
  SPORTCASH_DEPOSIT: "ser_refill_local_coupon",
  SPORTCASHCOUPON_DEPOSIT: "ser_refill_local_coupon",

  VIAMOBILE: "ser_refill_local_coupon",
  BANKTRANSFER: "ser_bank_transfer",

  PAYTUS_GATEWAY_DEPOSIT: "paytus-recharge",
  PAYTUS_GATEWAY_WITHDRAWAL: "paytus-retrait",
  LONAPAY_DEPOSIT: "paytus-recharge",
  LONAPAY_WITHDRAWAL: "paytus-retrait",

  SPORTCASHWITHDRAWAL_WITHDRAWAL: "ser_generate_withdrawal_code",
  BET216WITHDRAWAL: "ser_generate_withdrawal_code",
  BET221WITHDRAWAL: "ser_generate_withdrawal_code",
  BET221WITHDRAWAL_WITHDRAWAL: "ser_generate_withdrawal_code",
  SPORTCASH_WITHDRAWAL: "ser_generate_withdrawal_code",
  SPORTCASHCOUPON_WITHDRAWAL: "ser_generate_withdrawal_code",
}

export const TurfEndpoints = {
  getActiveGames: "soccer/get_active_games.jsp",
  getRaceReport: "ws_web_mobile_rapport.jsp",
};

export const expiry = 25;
export let SLIDER = {
  slides: [
    "slide_1.png",
    "slide_2.png",
    "slide_3.png",
    "slide_4.png",
    "slide_5.png",
    "slide_6.jpg",
  ],
};
export const GAME_TYPES = {
  CE: "Long Champ",
  SI: "Unitaire",
  CP: "Champ Reduit",
  CT: "Champ Total",
};

export const limits = {
  min: "400",
  max_ticket: "100000",
  max_online: "3275000",
  max_gain: "32750000",
  max_odds: "10000",
  max_event: "23",
};
export const defaults = {pin:"1096", code: "225"}


export const GameTypes = {
  CE: "C. Elargie",
  SI: "Simple",
  CP: "Champ Partiel",
  CT: "Champ Total",
};
